import { Component, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SpinnerService {
  public isLoading = new BehaviorSubject(false);
}
